import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import InfoIconSvg from "/resources/icons/InfoIcon.svg";

const InfoIconWrapper = styled.span`
    margin: auto 0;
`;

const StyledInfoIcon = styled(InfoIconSvg)`
    fill: ${(props) => props.theme.textColorSecondary};
    height: 12px;
    width: 12px;
`;

interface InfoIconProps {
    readonly tooltipId: string;
    readonly tooltipText?: string;
    readonly tooltipJsx?: JSX.Element;
    className?: string;
}
export default function InfoIcon(props: InfoIconProps) {
    const getTooltipContent = () => {
        return <>{props.tooltipJsx}</>;
    };

    return (
        <InfoIconWrapper
            data-for={props.tooltipId}
            data-tip={props.tooltipJsx ? "" : props.tooltipText}
            className={props.className}
        >
            <StyledInfoIcon />
            <ReactTooltip id={props.tooltipId} getContent={props.tooltipJsx ? getTooltipContent : null} />
        </InfoIconWrapper>
    );
}
